import { Box } from "@mui/material";
import { LoginHeader } from "components/features/LoginHeader";
import { Outlet, useNavigate } from "react-router-dom";
import { useAppSelector } from "../hooks";
import { selectAuth } from "../features/authSlice";
import { CustomLoader } from "../components/ui/CustomLoader";
import { AppRoutes } from "../types/enums";
import { useEffect, useState } from "react";

export const LoginLayout = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const { accessToken } = useAppSelector(selectAuth);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get("code");
    const state = urlParams.get("state");
    const { redirect_url } = state
      ? JSON.parse(atob(state || ""))
      : { redirect_url: null };

    if (accessToken) {
      navigate(
        `${redirect_url}?code=${code}&state=${state}` ?? AppRoutes.CAMPAIGNS,
        { replace: true },
      );
    } else if (redirect_url) {
      navigate(`${redirect_url}?code=${code}&state=${state}`, {
        replace: true,
      });
    } else setIsLoading(false);
  }, [accessToken]);

  if (isLoading) {
    return <CustomLoader />;
  }

  return (
    <Box>
      <LoginHeader />
      <Outlet />
    </Box>
  );
};
